<template>
  <div class="products">
    <div class="page-header">
      <h1>{{ $t('Marketing Management')}} > {{ $t('Time Period') }}</h1>
    </div>
    <div class="page-content">
      <div class="content-header">
        <h2>{{ $t('Time Period') }}</h2>
        <router-link :to="{ name: 'CreateTimePeriod' }">
          <el-button class="action-button" type="primary">{{ $t('Create') }}</el-button>
        </router-link>
      </div>

      <div class="promotions-list">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ $t('Time Period Name') }}</th>
              <th scope="col">{{ $t('Start Time') }}</th>
              <th scope="col">{{ $t('End Time') }}</th>
              <th scope="col">{{ $t('Discount') }}</th>
              <th scope="col">{{ $t('Actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="time in times">
              <td>{{ time.name }}</td>
              <td>{{ time.start_time }}</td>
              <td>{{ time.end_time }}</td>
              <td>{{ time.discount }}%</td>
              <td>
                <div class="action-links">
                  <router-link class="action-link" :to="{name:'ViewTimePeriod', params: {id: time.id}}">
                    {{ $t('Edit') }}
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ItemFilter from '@/components/Filter.vue';
import Common from '@/lib/common';
import Time from '@/lib/time';

export default {
  name: 'TimePeriod',
  components: {
    ItemFilter,
  },
  mounted(){
    this.loadAllTimes();
  },
  methods:{
    async loadAllTimes(){
      try{
        const loginInfo = Common.getLoginInfo();
        const times = await Time.loadAllTimes(this.apiUrl, loginInfo);
        this.times = times;
      }catch(err){
        console.log(err);
      }
    },
  },
  data(){
    return {
      times: [],
    }
  },
  computed: mapState({
   apiUrl: state => state.apiUrl,
 }),
}
</script>

<style scoped lang="scss">
.content-header{
  display: flex;
  h2{
    flex: 1;
  }
  .action-button{
    margin-right: 20px;
  }
}
.seat-list{
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
  .card{
    margin-bottom: 30px;
    margin-right: 20px;
    .btn-primary{
      margin-right: 30px;
    }
  }
}
</style>
